import IconSvgContainer, { IconProps, IconSize } from "../IconSvgContainer"

export default function EnergyIcon({ size = IconSize.medium }: IconProps) {
	return (
		<IconSvgContainer size={size} fill={true} viewBox={"0 0 28 48"}>
			<path d="M27.1064 19.9579H16.8159L20.7738 0L0.291687 28.0421H10.5822L6.62432 48L27.1064 19.9579Z" />
		</IconSvgContainer>
	)
}
